/**
 * Build-time feature flags for the SPA.
 *
 * @module lib/features
 */

/**
 * Payroll (cedolini) feature. Offline by default; set VITE_PAYROLL_ENABLED=true
 * at build time to restore the page, nav entry and API usage.
 * @type {boolean}
 */
export const PAYROLL_ENABLED = import.meta.env.VITE_PAYROLL_ENABLED === 'true';
